export default __webpack_public_path__ + "static/media/a4-print-label-3-page.c74b5bf5.svg";